module.exports = __webpack_public_path__ + "Flag-558.af18217ca2f4fc7c07be37612d109bbe.svg";